<template>
  <div>
    <px-view-header title="Aprovações de compra"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>

    <px-aprovacao-compra-header :on-click-refresh="onClickRefresh"
                                @change="onChange"/>
    <px-aprovacao-compra-list v-if="selectedStatus" ref="aprovacoesList" class="mt-3"/>
  </div>
</template>

<script>
import AprovacaoCompraHeader from '@/modules/aprovacao-compra/AprovacaoCompraHeader.vue';
import { mapGetters } from 'vuex';
import AprovacaoCompraList from '@/modules/aprovacao-compra/AprovacaoCompraList.vue';

export default {
  data() {
    return {
      aprovacaoId: this.$route.query.id,
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de compras' },
        {
          text: 'Aprovações de compra',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('listagemAprovacaoCompra', ['selectedStatus']),
  },
  methods: {
    onClickRefresh() {
      this.$refs.aprovacoesList.refresh();
    },
    onChange() {
      this.$refs.aprovacoesList.onChangeFilters();
    },
  },
  mounted() {
    if (this.aprovacaoId) {
      this.$refs.modalAprovacao.open();
    }
  },
  components: {
    pxAprovacaoCompraHeader: AprovacaoCompraHeader,
    pxAprovacaoCompraList: AprovacaoCompraList,
  },
};
</script>
